import React from 'react';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import './FooterStyle.css';


const Footer = () => {
    return (
        <footer className="footer-wrapper">
            <div className="footer-container">

                {/* Column 1: Brand */}
                <div className="footer-col brand-col">
                    <a href="#inicio" className="footer-logo-container">
                        <div className="footer-logo-text-wrapper">
                            <span className="footer-logo-text-primary">Autocarril</span>
                            <span className="footer-logo-text-secondary">Moviles</span>
                        </div>
                        <div className="footer-logo-icon-wrapper">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide-car">
                                <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H9.3a2 2 0 0 0-1.6.8L5 11l-5.16.86a1 1 0 0 0-.84.99V16h3" />
                                <circle cx="6.5" cy="16.5" r="2.5" />
                                <circle cx="17.5" cy="16.5" r="2.5" />
                            </svg>
                        </div>
                    </a>
                    <p className="footer-slogan">
                        30 años conectando destinos y cumpliendo sueños sobre ruedas. Calidad y confianza garantizada.
                    </p>
                    <div className="footer-socials">
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <Instagram size={24} />
                        </a>
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <Facebook size={24} />
                        </a>
                    </div>
                </div>

                {/* Column 2: Navigation */}
                <div className="footer-col nav-col">
                    <h3>Explorar</h3>
                    <ul>
                        <li><a href="#inicio">Inicio</a></li>
                        <li><a href="#nosotros">Nosotros</a></li>
                        <li><a href="#flota">Nuestros Autos</a></li>
                        <li><a href="#contacto">Contacto</a></li>
                    </ul>
                </div>

                {/* Column 3: Contact */}
                <div className="footer-col contact-col">
                    <h3>Contacto</h3>
                    <div className="contact-row">
                        <MapPin size={20} className="footer-icon" />
                        <span>Av. Salvador M. del Carril 2131, CABA</span>
                    </div>
                    <div className="contact-row">
                        <Phone size={20} className="footer-icon" />
                        <span>+54 11 3935-9902</span>
                    </div>
                    <div className="contact-row">
                        <Mail size={20} className="footer-icon" />
                        <span>contacto@autocarril.com</span>
                    </div>
                </div>

            </div>

            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Autocarril. Todos los derechos reservados.</p>
                <p className="credits">
                    Desarrollado por Leandro Bevilacqua | <a href="mailto:leabevi@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>leabevi@gmail.com</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
